import { useCallback } from 'react';
import { useIntl } from 'react-intl';

import { Text } from '@fhs/ui';
import { selectors } from '@fhs-legacy/frontend/src/state/global-state';
import { useAppSelector } from '@fhs-legacy/frontend/src/state/global-state';
import { InlineAlert } from '@fhs-legacy/universal-components';

export const useMaxRedemptionLimitAlert = () => {
  const intl = useIntl();
  const { formatMessage } = intl;

  const hasReachedMaxRedemptionLimit = useAppSelector(
    selectors.loyalty.createHasReachedMaxRedemptionLimitSelector(intl)
  );
  const maximumDailyRewardRedemptionLimit = useAppSelector(
    selectors.loyalty.selectMaxDailyRewardRedemptionLimit
  );

  const renderMaxRedemptionLimitAlert = useCallback(() => {
    if (!hasReachedMaxRedemptionLimit) {
      return null;
    }
    return (
      <InlineAlert
        status="error"
        title={
          <Text.Heading type="four">
            {formatMessage({
              id: 'dailyRedemptionLimit',
            })}
          </Text.Heading>
        }
        borderRadius={8}
        marginTop="$4"
        message={
          <Text.Ui size="sm">
            {formatMessage(
              { id: 'dailyRedemptionLimitMessage' },
              {
                boldText: (
                  <Text.Ui size="sm" weight="bold">
                    {formatMessage(
                      { id: 'dailyRedemptionLimitDetail' },
                      {
                        maxLimitRedemption: maximumDailyRewardRedemptionLimit,
                      }
                    )}
                  </Text.Ui>
                ),
              }
            )}
          </Text.Ui>
        }
      />
    );
  }, [hasReachedMaxRedemptionLimit, maximumDailyRewardRedemptionLimit, formatMessage]);

  return renderMaxRedemptionLimitAlert;
};
